import { useQuery } from '@tanstack/react-query';
import { fetchAgreementSoldItems } from '../services/agreements';
import { agreementKeys } from './agreementKeys';

/** Gated on the Invoicing tab being active (design 6.2): the caller passes `enabled`. */
export function useAgreementSoldItemsQuery(id: string | undefined, enabled: boolean) {
    return useQuery({
        queryKey: agreementKeys.soldItems(id ?? ''),
        queryFn: () => fetchAgreementSoldItems(id!),
        enabled: !!id && enabled,
    });
}
